import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const switchChipGroupStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;

// Legacy (isNew=false) styles
export const switchChipBaseStyle = css`
  max-width: 144px;
`;

export const switchChipSelectedBaseStyle = css`
  transition: background-color 0.2s ease-in-out;
  background-color: ${theme.colors.primary50};
  color: ${theme.colors.white};
  border: 1px solid ${theme.colors.primary50};
`;

export const switchChipSelectedDisabledStyle = css`
  background-color: ${theme.colors.primary20};
`;

export const switchChipSelectedEnabledStyle = css`
  cursor: pointer;
  &:hover {
    background-color: ${theme.colors.primary60};
  }
`;

export const switchChipUnselectedBaseStyle = css`
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
`;

export const switchChipUnselectedDisabledStyle = css`
  border-color: ${theme.colors.neutral20};
  color: ${theme.colors.neutral20};
`;

export const switchChipUnselectedEnabledStyle = css`
  cursor: pointer;
  &:hover {
    background-color: ${theme.colors.neutral10};
    border-color: ${theme.colors.neutral10};
  }
`;

// New design (isNew=true) styles
export const switchChipNewBaseStyle = css`
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
`;

export const switchChipNewSelectedStyle = css`
  cursor: pointer;
  background-color: ${theme.colors.primary5};
  border: 1px solid transparent;
  color: ${theme.colors.neutral90};
`;

export const switchChipNewUnselectedStyle = css`
  cursor: pointer;
  border: 1px solid ${theme.colors.neutral50};
  color: ${theme.colors.neutral90};
  &:hover {
    background-color: ${theme.colors.neutral10};
    border: 1px solid transparent;
  }
`;

export const switchChipNewDisabledSelectedStyle = css`
  cursor: not-allowed;
  background: ${theme.colors.primary5};
  color: ${theme.colors.neutral90};
`;

export const switchChipNewDisabledUnselectedStyle = css`
  cursor: not-allowed;
  background: ${theme.colors.neutral5};
  border: 1px solid ${theme.colors.neutral20};
  color: ${theme.colors.neutral90};
`;
